// extracted by mini-css-extract-plugin
export default {"productGallery":"xH-z","inQuickShop":"yH-z"};